import { useState } from 'react'
import { Link, useLocation } from 'react-router'
import { useSessione } from '../servizi/sessione.tsx'
import { sistemaTelefono } from '../servizi/app-nativa.ts'
import { rimanda, rimandato, useInvitoAppServe } from '../servizi/app-telefono.ts'
import { BottoneIcona } from './base.tsx'
import { IconaChiudi, IconaTelefono } from './Icone.tsx'

/**
 * Invito a installare l'app sopra la pagina (decisione di Davide dell'1/11/2026), nella stessa forma delle
 * altre righe in cima (secondo fattore, email di recupero, novità): un'icona, una frase, un collegamento, la
 * crocetta. Porta al riquadro «App per il telefono» del profilo (AppTelefono.tsx, ancora `app-telefono`).
 *
 * Non compare sul cruscotto, che ha il suo banner con il codice QR o il pulsante (BannerAppTelefono.tsx), ne'
 * nel profilo, dove il riquadro e' gia' li'. Non compare nemmeno dove l'app non serve (servizi/app-telefono.ts).
 * La crocetta lo nasconde per sette giorni.
 */
export function AvvisoAppTelefono() {
  const { io } = useSessione()
  const { pathname } = useLocation()
  const [chiuso, setChiuso] = useState(false)
  const serve = useInvitoAppServe(io)
  if (!io || !serve || chiuso || pathname === '/' || pathname === '/profilo' || rimandato('piu-tardi', io.id)) return null
  const s = sistemaTelefono()
  const chiudi = () => { rimanda('piu-tardi', io.id, 7); setChiuso(true) }

  return (
    <div className="fattore-avviso invito" role="status">
      <IconaTelefono />
      <p>
        {s === 'android' ? (
          <><strong>Installa l’app CIDIS</strong>: resta connessa e si sblocca con l’impronta o il volto. </>
        ) : s === 'iphone' ? (
          <><strong>Aggiungi il gestionale alla schermata Home</strong>: si apre come un’app e si sblocca con
            Face ID. </>
        ) : (
          <><strong>Il gestionale anche sul telefono</strong>: l’app CIDIS su Android, la schermata Home
            sull’iPhone. </>
        )}
        <Link to="/profilo#app-telefono">{s === 'altro' ? 'Come fare' : 'Installa'}</Link>
      </p>
      <BottoneIcona icona={<IconaChiudi />} etichetta="Chiudi l’invito ad installare l’app per sette giorni"
                    onClick={chiudi} />
    </div>
  )
}
